<div class="flex w-full max-w-[50%] flex-row items-center">
  <app-message-name-avatar name="Boris Joskic"></app-message-name-avatar>

  <div class="ml-3 flex flex-col">
    <p class="text-xs font-medium leading-3 text-[var(--neutral-50)]">David Foster - Gate</p>
    <p>msg</p>
    <p class="text-xs font-medium leading-3 text-[var(--neutral-50)]">03/24/25 04:24 PM</p>
  </div>
</div>
